let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ekAXv")).then(() => parcelRequire('7zEKu'));